<t4-header icon="glyphicon-stats"></t4-header>
<t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
<t4-container>
  <t4-data-table #tbl reportName="TrailerOverviewReport" headline="" [parameters]="{from: fromDate, to:toDate}" [autoGenerateColumns]="false" matSort [filterFields]="['RegNo']">

    <ng-container matColumnDef="RegNo">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>RegNo</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> <t4-object-link objectId="{{row.Id}}" style="min-width:90px;">{{row.RegNo}}</t4-object-link></mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="StartDate">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>StartDate</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.StartDate | date:'longDate'}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="DeletedAt">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>DeletedAt</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.DeletedAt | date:'longDate'}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Availability">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>Availability</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.Availability | percent }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="AmountOfRentals">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>AmountOfRentals</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.AmountOfRentals}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="MonthlyCost">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>MonthlyCost</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.MonthlyCost}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="TotalRentOverPeriod">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>TotalRentOverPeriod</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.TotalRentOverPeriod}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="RentalIncome">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>RentalIncome</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.RentalIncome}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="Sum">
      <mat-header-cell *matHeaderCellDef style="min-width: 90px;" mat-sort-header>Sum</mat-header-cell>
      <mat-cell *matCellDef="let row" style="min-width: 90px;"> {{row.Sum}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="min-width: 90px; font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>


  </t4-data-table>
</t4-container>
